import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=bcf8e88e&scoped=true"
import script from "./HistoryModal.vue?vue&type=script&lang=js"
export * from "./HistoryModal.vue?vue&type=script&lang=js"
import style0 from "./HistoryModal.vue?vue&type=style&index=0&id=bcf8e88e&prod&scoped=true&lang=css"
import style1 from "./HistoryModal.vue?vue&type=style&index=1&id=bcf8e88e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf8e88e",
  null
  
)

export default component.exports